import { cloneDeep, isEmpty, isEqual } from 'lodash'
import React, { createRef } from 'react'
import { withTranslation } from 'react-i18next'
import Footer from '../../../../../../../common/components/Modal/components/Footer/Footer'
import Header from '../../../../../../../common/components/Modal/components/Header/Header'
import Modal from '../../../../../../../common/components/Modal/Modal'
import { Card, isValidCardsBlock, collectCardsErrors } from './cardService'
import './CardsModal.scss'
import CardsView from './views/CardsView'
import { clearObjectErrors } from '../../../../../../../common/utils/validatorService'

const FIXED_TOP_OFFSET_FOR_SCROLL = 36

class CardsModal extends React.Component {
    constructor(props) {
        super(props)
        let tmpStructure = cloneDeep(props.data.structure)
        this.state = {
            quitAcceptIsOpen: false,
            tmpStructure: tmpStructure,
            focusedCardId: this.findFirstCardId(tmpStructure),
            cardsErrors: new Map(),
        }

        this.scrollableCardContentNodeRef = createRef()
    }

    findFirstCardId(structure) {
        return !isEmpty(structure.cards) ? structure.cards[0].id : null
    }

    onSave = async () => {
        const {
            methods: { save, closeModal },
            data: { id },
        } = this.props
        const { tmpStructure } = this.state

        // TODO need to add normalization step
        let isValid = isValidCardsBlock(tmpStructure)
        if (!isValid) {
            let cardsErrors = collectCardsErrors(tmpStructure)
            this.setState({ cardsErrors: cardsErrors.cards })
        } else await save({ [id]: { data: { struct: tmpStructure } } })

        if (isValid) closeModal()
    }

    onClose = () => {
        const {
            methods: { closeModal },
            data,
        } = this.props
        const { tmpStructure } = this.state
        // TODO need to add normalization step
        // const normalizedStructure = getNormalizedStructure(tmpStructure)

        if (!isEqual(data.structure, tmpStructure)) {
            this.setState({ quitAcceptIsOpen: true })
        } else {
            closeModal()
        }
    }

    setFocusToCard = cardElement => {
        let { focusedItemId } = this.state
        const cardId = cardElement.id
        if (cardId !== focusedItemId) this.setState({ focusedCardId: cardId })
    }

    onClickNavigateToCard = cardId => {
        this.scrollContainerToCard(cardId)
    }

    scrollContainerToCard = id => {
        let element = document.getElementById(id)
        this.scrollableCardContentNodeRef.current.scrollTo({
            top: element.offsetTop - FIXED_TOP_OFFSET_FOR_SCROLL,
            left: 0,
            behavior: 'smooth',
        })
    }

    onAddCard = async () => {
        let card = new Card({})
        await this.setState(prevState => {
            const cards = prevState.tmpStructure.cards.concat(card)

            return {
                ...prevState,
                tmpStructure: {
                    cards: cards,
                },
            }
        })
        this.scrollContainerToCard(card.id)
    }

    onCloneCard = async cardId => {
        let clonedCard = null
        await this.setState(prevState => {
            let sourceCard = prevState.tmpStructure.cards.find(card => card.id === cardId)
            clonedCard = new Card(sourceCard)
            const cards = prevState.tmpStructure.cards.concat(clonedCard)

            return {
                ...prevState,
                tmpStructure: {
                    cards: cards,
                },
            }
        })
        this.scrollContainerToCard(clonedCard.id)
    }

    onUpdateCard = (itemId, newFields) => {
        this.setState(prevState => {
            const cardsErrors = cloneDeep(prevState.cardsErrors)
            let cardErrors = cardsErrors.get(itemId)
            if (cardErrors) {
                clearObjectErrors(cardErrors, Object.keys(newFields))
                const cardIsValid = Object.values(cardErrors).some(val => isEmpty(val))
                if (cardIsValid) cardsErrors.delete(itemId)
            }
            return {
                ...prevState,
                tmpStructure: {
                    cards: prevState.tmpStructure.cards.map(item =>
                        itemId === item.id ? { ...item, ...newFields } : item,
                    ),
                },
                cardsErrors: cardsErrors,
            }
        })
    }

    onRemoveCard = cardId => {
        this.setState(prevState => {
            const cards = prevState.tmpStructure.cards.filter(item => cardId !== item.id)

            return {
                ...prevState,
                tmpStructure: {
                    cards: cards,
                },
            }
        })
    }

    onChangeCardPosition = (currentIndex, newIndex) => {
        this.setState(prevState => {
            const cards = cloneDeep(prevState.tmpStructure.cards)
            const movingCard = cards[currentIndex]
            cards[currentIndex] = cards[newIndex]
            cards[newIndex] = movingCard
            return {
                ...prevState,
                tmpStructure: {
                    cards: cards,
                },
            }
        })
    }

    render() {
        const { tmpStructure, cardsErrors, focusedCardId, isSaving } = this.state

        const { t, methods } = this.props

        return (
            <Modal onClose={methods.closeModal}>
                <Header title={t('Card options')} onClose={methods.closeModal} />
                <div className="card-dialog">
                    <CardsView
                        cards={tmpStructure.cards}
                        errors={cardsErrors}
                        scrollableCardContentNodeRef={this.scrollableCardContentNodeRef}
                        focusedCardId={focusedCardId}
                        methods={{
                            openAssetManager: methods.openAssetManager,
                            setFocusToCard: this.setFocusToCard,
                            navigateToCard: this.onClickNavigateToCard,
                            addNewCard: this.onAddCard,
                            cloneCard: this.onCloneCard,
                            updateCard: this.onUpdateCard,
                            removeCard: this.onRemoveCard,
                            changeCardPosition: this.onChangeCardPosition,
                        }}
                    />
                </div>
                <Footer
                    actionText={t('Save')}
                    cancelText={t('Cancel')}
                    onAction={this.onSave}
                    onClose={methods.closeModal}
                    isActionDisabled={isSaving}
                />
            </Modal>
        )
    }
}

export default withTranslation('translations')(CardsModal)
